import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { GetUserInfo } from "../../utils/permissionChecker";
import { Nav, Tab } from "react-bootstrap";
import EkycAssignment from "./branchEkycDeviceAssignment.js";
import TaskAssignment from "./branchTaskAssignment.js";
const BranchEmpAssignment = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const branch = user?.employee?.branch_id;
  return (
    <>
      <Tab.Container defaultActiveKey="home-tab">
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="home-tab">Ekyc Assignment </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="profile-tab">Task Assignment</Nav.Link>
          </Nav.Item>
          {/* <Nav.Item>
            <Nav.Link eventKey="contact-tab">Contact</Nav.Link>
          </Nav.Item> */}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="home-tab">
            <EkycAssignment />
          </Tab.Pane>
          <Tab.Pane eventKey="profile-tab">
            <TaskAssignment />
          </Tab.Pane>
          <Tab.Pane eventKey="contact-tab">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};
export default BranchEmpAssignment;
